"use strict";
import Questions from "./Questions";
import Choice from "./Choice";

class Choices {
    readonly _questions: Questions;
    private _questionId: string;

    constructor(questions, questionId) {
        this._questions = questions;
        this._questionId = questionId;
    }

    get questionId() {
        return this._questionId;
    }

    get _q() {
        return this._questions._qGetRawCustomQuestion(this._questionId);
    }

    get _choices() {
        return this._q.choices || {};
    }

    _getRawChoice(choiceId) {
        if (choiceId in this._choices) {
            return this._choices[choiceId];
        }
    }

    asSortedArray() {
        return Object.keys(this._choices || {}).map(k => new Choice(this, k)).sort(function (c1, c2) {
            const s1 = c1.sortKey;
            const s2 = c2.sortKey;
            return (s1 == s2) ? 0 : ((s1 < s2) ? -1 : +1);
        });
    }

    choiceFromJson(choiceJson) {
        //Todo: make this a deep comparision
        var matchedChoices = this.asSortedArray().filter(c => (c.storeValue == choiceJson));
        if (matchedChoices.length > 0) {
            return matchedChoices[0];
        }
        return null;
    }

    toString() {
        return "[" + this.asSortedArray().map(c => c.toString()).join(", ") + "]";
    }

    addCustomChoiceWithDisplayValue(displayValue) {
        const choice = {
            display: { v: displayValue },
            storeValue: this.nextCustomId()
        };
        return this._questions._qWriteRawCustomQuestionChoice(this._questionId, choice.storeValue, choice);
    }

    getChoiceWithStoreValue(storeValue) {
        return this.asSortedArray()
          .filter(c => (c.storeValue == storeValue))[0];
    }

    nextCustomId() {
        const makeId = (x = 1) => {
            const id = `custom${x}`;
            if (this._getRawChoice(id)) return makeId(x + 1);
            return id;
        };
        return makeId();
    }

    getChoiceById(choiceId) {
        return this.asSortedArray()
            .filter(c => (c.id == choiceId))[0];
    }
}

export default Choices;